import { useState } from "react";

const isBrowser = typeof window !== "undefined";

const getItem = key =>
    isBrowser ? document.cookie.split("; ").reduce((total, currentCookie) => {
        const item = currentCookie.split("=");
        const storedKey = item[0];
        const storedValue = item[1];

        return key === storedKey ? decodeURIComponent(storedValue) : total;
    }, "") : undefined;

const setItem = (key, value, numberOfDays) => {
    if (!isBrowser) return;
    const now = new Date();

    // set the time to be now + numberOfDays
    if (numberOfDays) now.setTime(now.getTime() + numberOfDays * 60 * 60 * 24 * 1000);
    document.cookie = `${key}=${value}; expires=${numberOfDays ? now.toUTCString(): `0`}; path=/`;
};

/**
 *
 * @param {String} key The key to store our data to
 * @param {String|undefined} defaultValue The default value to return in case the cookie doesn't exist
 */
export const useCookie = (key, defaultValue) => {
    const getCookie = () => getItem(key) || defaultValue;
    const [cookie, setCookie] = useState(getCookie());

    const updateCookie = (value, numberOfDays) => {
        setCookie(value);
        setItem(key, value, numberOfDays);
    };

    return [cookie, updateCookie];
};

export default useCookie;
